// slices/loaderSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  activeLink: 'dashboard',
};

const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    loaderStateTrue: (state) => {
      state.isLoading = true;
    },
    loaderStateFalse: (state) => {
      state.isLoading = false;
    },
    setActiveLink: (state, action) => {
      state.activeLink = action.payload;
    },
  },
});

export const { loaderStateTrue, loaderStateFalse, setActiveLink } = loaderSlice.actions;
export default loaderSlice.reducer;